import { SAVE_COUNTRY_MASTER } from '../constants'

const initState = {
	request: null,
	response: null,
	error: null,
}

export default (state = initState, action) => {
	switch (action.type) {
		case SAVE_COUNTRY_MASTER.LOAD:
			return {
				...state,
				request: action.payload,
				response: null,
				error: null,
			}
		case SAVE_COUNTRY_MASTER.SUCCESS:
			return {
				...state,
				response: action.response,
			}
		case SAVE_COUNTRY_MASTER.ERROR:
			return {
				...state,
				error: action.error,
			}
		default:
			return state
	}
}